import moment from 'moment'
import React, { useState } from 'react'

import LineCheckIcon from 'components/Luxkit/Icons/line/LineCheckIcon'
import ListItem from 'components/Luxkit/List/ListItem'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import { SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

interface Props {
  startDate: moment.Moment
  endDate: moment.Moment
  selectedDate?: moment.Moment
}

function DatesModal({
  startDate,
  endDate,
  selectedDate: initialSelectedDate,
}: Props) {
  const modalElement = useModalElementContext<
    moment.Moment | null | undefined
  >()

  const days = endDate.diff(startDate, 'days') + 1
  const clonedStartDate = startDate.clone().startOf('day')

  const [selection, setSelection] = useState<moment.Moment | null | undefined>(
    initialSelectedDate,
  )

  return (
    <ModalBase height="auto">
      <ModalHeader
        title="Add to itinerary"
        onCloseButtonClick={() => modalElement.resolve(undefined)}
      />
      <ModalBody>
        <ModalContent>
          {initialSelectedDate && (
            <ListItem
              onClick={() => setSelection(null)}
              selected={selection === null}
              endIcon={selection === null ? <LineCheckIcon /> : undefined}
              title="Remove date"
            />
          )}
          {[...Array(days).keys()].map((i) => {
            const currentDate = clonedStartDate.clone().add(i, 'day')
            const isSelected =
              moment.isMoment(selection) && selection.isSame(currentDate, 'day')

            return (
              <ListItem
                key={currentDate.unix()}
                onClick={() => setSelection(currentDate)}
                selected={isSelected}
                title={currentDate.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
                endIcon={isSelected ? <LineCheckIcon /> : undefined}
              />
            )
          })}
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Save',
          onClick: () => {
            modalElement.resolve(selection)
          },
          disabled: selection === undefined,
        }}
      />
    </ModalBase>
  )
}

export default DatesModal
